export default __webpack_public_path__ + "static/media/all-done.85582784.png";